import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckoutButton } from "./CheckoutButton";
import { TikTokIcon, LinkedInIcon } from "./Scott";
import { useSite, useImages } from "@/context/SiteContent";

const FaqItem = ({ q, a, defaultOpen, idx }) => {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <details className="reveal" open={open} onToggle={(e) => setOpen(e.target.open)} data-testid={`faq-item-${idx}`}>
      <summary>{q}<span>{open ? "−" : "+"}</span></summary>
      <p>{a}</p>
    </details>
  );
};

export const Faq = () => {
  const { faqs } = useSite();
  return (
  <section className="faq-section" id="faq" data-testid="faq-section">
    <div className="container">
      <div className="reveal" style={{ maxWidth: 800, margin: "auto", textAlign: "center" }}>
        <div className="eyebrow">Frequently Asked Questions</div>
        <h2 style={{ marginTop: 10, color: "var(--green)" }}>Before you decide.</h2>
      </div>
      <div className="faq">{faqs.map(({ q, a }, i) => <FaqItem key={q} q={q} a={a} defaultOpen={i === 0} idx={i} />)}</div>
    </div>
  </section>
  );
};

export const Final = () => {
  const { price, bookingCta } = useSite();
  return (
  <section className="final" data-testid="final-section">
    <div className="container final-inner reveal">
      <div className="eyebrow">Same journey. Brighter tomorrows.</div>
      <h2 style={{ color: "white", marginTop: 10 }}>Your future self will thank you for starting earlier.</h2>
      <p className="lead">You do not need your whole life figured out. Start by learning how to navigate the transition in front of you, then build from there.</p>
      <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginTop: 22 }}>
        <CheckoutButton testId="final-checkout-btn">Get the eBook • {price}</CheckoutButton>
        <a className="btn btn-outline" href="#booking" data-testid="final-booking-btn">{bookingCta}</a>
      </div>
      <a className="hero-quiz-textlink" href="#quiz" data-testid="final-quiz-btn" style={{ marginTop: 16 }}>Take the 5Ps Quiz →</a>
    </div>
  </section>
  );
};

export const Footer = () => {
  const { links, price, brandStory } = useSite();
  const images = useImages();
  return (
  <footer className="footer ft" data-testid="site-footer">
    <div className="footer-bg-orb orb-one" /><div className="footer-bg-orb orb-two" />
    <div className="container ft-wrap">
      <div className="ft-top reveal">
        <div className="ft-brand">
          <a href="#top" className="ft-logo-link"><img alt="TransitionWorks" className="ft-logo" src={images.logoLight} /></a>
          <p className="ft-tagline">Helping people navigate life's important transitions with greater clarity, confidence and practical knowledge.</p>
          <p className="ft-theme" data-testid="footer-brand-theme">TransitionWorks · {(brandStory && brandStory.theme) || "From Potential to Performance"}</p>
          <div className="ft-socials">
            <a className="ft-social" href={links.tiktok} rel="noopener noreferrer" target="_blank" data-testid="footer-tiktok-link"><TikTokIcon /><span>TikTok</span><small>@campustocorporate1</small></a>
            <a className="ft-social" href={links.linkedin} rel="noopener noreferrer" target="_blank" data-testid="footer-linkedin-link"><LinkedInIcon /><span>LinkedIn</span><small>Scott Tang</small></a>
          </div>
        </div>
        <nav className="ft-cols" aria-label="Footer">
          <div className="ft-col">
            <span className="ft-title">Explore</span>
            <a href="#fiveps">The 5Ps</a>
            <a href="#ebook">What's inside the eBook</a>
            <a href="#quiz">Take the 5Ps Quiz</a>
            <a href="#library">Lesson Explorer</a>
            <a href="#scott">About Scott Tang</a>
          </div>
          <div className="ft-col">
            <span className="ft-title">Next steps</span>
            <CheckoutButton className="" testId="footer-checkout-link">Get the eBook · {price}</CheckoutButton>
            <a href="#booking" data-testid="footer-booking-link">Book a 5Ps Conversation</a>
            <Link to="/read" data-testid="footer-read-link">Read your eBook</Link>
            <a href="#ask">Ask Scottie</a>
            <a href="#faq">Frequently Asked Questions</a>
          </div>
          <div className="ft-col">
            <span className="ft-title">Legal</span>
            <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link">Terms of Use</Link>
            <Link to="/disclaimer" data-testid="footer-disclaimer-link">Educational Disclaimer</Link>
          </div>
        </nav>
      </div>
      <div className="ft-bottom reveal">
        <div className="ft-meta"><strong>TransitionWorks</strong><span>Registered Company Name: TRANSITIONWORKS · UEN 53530089A</span></div>
        <div className="ft-copy"><span>© 2026 TransitionWorks. All rights reserved.</span><span className="ft-motto">Same journey. Brighter tomorrows.</span></div>
      </div>
      <p className="ft-disclaimer reveal"><strong>Educational content only.</strong> Campus2Corp and TransitionWorks content is provided for general educational and informational purposes. It does not constitute financial, investment, tax, legal, employment or other professional advice. Individual circumstances and outcomes vary.</p>
    </div>
  </footer>
  );
};
